export default ['#2ab5ba', '#ff0000', '#e5a309', '#00bf03', '#f800df', '#0032e0', '#a567eb', '#b3f591', '#cb5f2d'];
